import React from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { AboutHero } from '../components/about/AboutHero';
import { AboutMission } from '../components/about/AboutMission';
import { AboutDirector } from '../components/about/AboutDirector';
import { AboutVision } from '../components/about/AboutVision';
import { AboutStandards } from '../components/about/AboutStandards';
import { AboutStaffCTA } from '../components/about/AboutStaffCTA';
import { AboutConsultCTA } from '../components/about/AboutConsultCTA';
export function AboutPage() {
  return <div className="min-h-screen w-full bg-black font-body" style={{
    scrollBehavior: 'smooth'
  }} data-id="element-2411">
      <Navigation data-id="element-2412" />
      <main data-id="element-2413">
        <AboutHero data-id="element-2414" />
        <AboutMission data-id="element-2415" />
        <AboutDirector data-id="element-2416" />
        <AboutVision data-id="element-2417" />
        <AboutStandards data-id="element-2418" />
        <AboutStaffCTA data-id="element-2419" />
        <AboutConsultCTA data-id="element-2420" />
      </main>
      <Footer data-id="element-2421" />
    </div>;
}